module.exports = __webpack_public_path__ + "components/MapControl/svg/Łowisko.svg?b034ce65";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Łowisko.svg
// module id = 2057
// module chunks = 0